export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    search: 'Search',
    clear: 'Clear',
    all: 'All',
    available: 'Available',
    sold: 'Sold',
    reserved: 'Reserved',
    occupied: 'Occupied',
    total: 'Total',
    value: 'Value',
    price: 'Price',
    date: 'Date',
    lottery: 'Lottery',
    organizer: 'Organizer',
    processing: 'Processing...',
    ticketsSingular: 'ticket',
    ticketsPlural: 'tickets',
    selectedSingular: 'selected',
    selectedPlural: 'selected'
  },

  // Raffle Page
  raffle: {
    loadingRaffle: 'Loading raffle...',
    raffleNotFound: 'Raffle not found',
    verifyLink: 'Please verify the link is correct',
    errorLoading: 'Error loading raffle',
    raffleNumber: 'Raffle #',
    drawDate: 'Draw Date',
    noNumber: 'No number',
    showingSample: 'Showing a sample of tickets. Use the search to find specific numbers.',
    showingSampleDesktop: 'Showing a random sample of tickets. Use the search to find specific numbers.'
  },

  // Ticket actions
  tickets: {
    searchTicket: 'Search number...',
    searchPlaceholder: 'Search number (e.g.: 42, 15, 73)',
    searchMultiple: 'You can search multiple numbers by separating them with commas',
    multipleSelection: 'Multiple Selection',
    multipleSelectionActive: '✓ Multiple Selection',
    multipleSelectionActiveDesktop: '✓ Multiple Selection Active',
    activateMultipleSelection: 'Activate Multiple Selection',
    randomNumbers: 'numbers',
    randomSelection: 'Lucky Pick',
    reserveAll: 'Reserve All',
    reserveSelected: 'Reserve Selected',
    clearSelection: 'Clear',
    ticketOccupied: 'This ticket is already taken',
    noAvailableTickets: 'No available tickets',
    onlyAvailable: 'Only {count} tickets available',
    randomTicketsAdded: '{count} random numbers added',
    noTicketsSelected: 'No tickets selected',
    ticketsSelected: '{count} tickets selected',
    noResults: 'No tickets found',
    noResultsFor: 'No results found for "{search}"',
    clearSearch: 'Clear search'
  },

  // Private Mode
  privateMode: {
    title: 'Private Mode',
    description: 'This raffle is in private mode. Search for your number to check availability.',
    searchButton: 'Search my number',
    searchNumbers: 'Search Numbers'
  },

  // Ticket Modal
  modal: {
    reserveTicket: 'Reserve Ticket',
    reserveTickets: 'Reserve {count} Tickets',
    personalInfo: 'Personal Information',
    fullName: 'Full name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    specialNote: 'Send special note',
    writeNote: 'Write your note here...',
    confirmNote: 'Upon confirmation, the raffle owner will contact you.',
    requiredFields: 'Please fill in the required fields',
    ticketReserved: 'Ticket {number} reserved successfully!',
    ticketsReserved: '{count} tickets reserved successfully!',
    errorReserving: 'Error reserving ticket. Please try again.',
    errorReservingMultiple: 'Error reserving tickets. Please try again.',
    selectedNumbers: 'Selected numbers:',
    totalValue: 'Total value'
  },

  // Placeholders
  placeholders: {
    name: 'John Doe',
    phone: '555 123 4567',
    email: 'email@example.com',
    address: '123 Main St'
  },

  // Stats
  stats: {
    available: 'Available',
    reserved: 'Reserved',
    sold: 'Sold',
    occupied: 'Occupied'
  },

  // Auth Pages
  auth: {
    login: {
      title: 'Sign In',
      or: 'Or',
      createAccount: 'create a new account',
      email: 'Email address',
      password: 'Password',
      forgotPassword: 'Forgot your password?',
      loggingIn: 'Signing in...',
      loginButton: 'Sign In'
    },
    register: {
      title: 'Create Account',
      titleNew: 'Create new account',
      or: 'Or',
      haveAccount: 'already have an account',
      loginIfHaveAccount: 'sign in if you already have an account',
      fullName: 'Full name',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      registering: 'Creating account...',
      registerButton: 'Create account',
      passwordMismatch: 'Passwords do not match',
      accountType: 'Account type',
      userAccount: 'User (Raffle organizer)',
      vendorAccount: 'Vendor',
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Password must be at least 6 characters',
      passwordPlaceholder: 'Minimum 6 characters',
      repeatPassword: 'Repeat password'
    },
    forgotPassword: {
      title: 'Reset Password',
      description: 'Enter your email address and we will send you a link to reset your password.',
      email: 'Email address',
      sending: 'Sending...',
      sendButton: 'Send link',
      backToLogin: 'Back to sign in',
      success: 'A link has been sent to your email',
      error: 'Error sending link. Please try again.'
    }
  },

  // Error Pages
  errorPages: {
    notFound: {
      title: '404',
      subtitle: 'Page not found',
      description: 'Sorry, we couldn\'t find the page you\'re looking for.',
      backHome: 'Back to home'
    },
    unauthorized: {
      title: '401',
      subtitle: 'Unauthorized',
      description: 'You don\'t have permission to access this page.',
      login: 'Sign in'
    }
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    myRaffles: 'My Raffles',
    createRaffle: 'Create Raffle',
    logout: 'Logout'
  }
};